import Images from '../assets/img/Images.js'
import React from "react"
import { useState, useEffect, useMountEffect } from 'react'
import '../App.css'
import { nftContractAddress, whiteListedUsers } from '../config.js'
import { BigNumber, ethers } from 'ethers'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaTwitter } from "react-icons/fa";
// import axios from 'axios'
import NFT from '../utils/RockyInu.json'
const Hero = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [menuOverlay, setMenuOverlay] = useState(false)
  const [currentAccount, setCurrentAccount] = useState('')
  const [counter, setCounter] = useState(1)
  const [miningStatus, setMiningStatus] = useState(0)

  const [loadingState, setLoadingState] = useState(0)
  const [mintedNFT, setMintedNFT] = useState(0)
  const [correctNetwork, setCorrectNetwork] = useState(false)
  const [mintButtonText, setMintButtonText] = useState("MINT NOW")
  const [totalminted, setTotalMinted] = useState(0)

  const connectWallet = async () => {

    try {
      const { ethereum } = window
      if (!ethereum) {
        console.log('Metamask not detected')
        return
      }
      let chainId = await ethereum.request({ method: 'eth_chainId' })
      console.log('Connected to chain:' + chainId)

      const ethMainnet = '0x1'
      const rinkebychainid = '0x4'

      if (chainId !== ethMainnet) {

        toast.warning("You are not connected to Ethereum network \n", {
          toastId: 'warning1',
        })
        return
      }

      const accounts = await ethereum.request({ method: 'eth_requestAccounts' })

      console.log('Found account', accounts[0])
      setCurrentAccount(accounts[0])
      toast.success("Wallet connected successfully \n", {
        toastId: 'success1',
      })

      window.location.reload();

    } catch (error) {

      let errordata = error.data ? error.data.message.split(":")[1] : error.message.split(":")[1]
      setMintButtonText("connect your wallet first")
      toast.warning("Please connect your wallet \n", {
        toastId: 'warning1',
      })
      console.log("Error:", errordata)

    }
  }

  function classHandler() {
    setMenuOverlay(!menuOverlay)
    setIsOpen(!isOpen)
    // setMenuOverlay(
    //   menuOverlay === 'navbar-smallScreen-overlayClose'
    //     ? 'navbar-smallScreen-overlayOpen'
    //     : 'navbar-smallScreen-overlayClose'
    // )
    // setIsOpen(isOpen === 'close' ? 'open' : 'close')
  }
  const mintCharacter = async () => {
    try {
      const { ethereum } = window
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum)
        const signer = provider.getSigner()
        const nftContract = new ethers.Contract(
          nftContractAddress,
          NFT.abi,
          signer
        )

        let nftTx
        let cost
        let owner = await nftContract.owner()
        owner = owner.toLowerCase()
        const num = { counter }
        const currentAcc = currentAccount.toLowerCase()

        cost = await nftContract.cost()
        const costinEth = cost / 1E18

        let totalCost = costinEth * num.counter
        if (owner == currentAcc) {

          totalCost = 0
        }


        nftTx = await nftContract.mintNFT(BigNumber.from(num.counter), { value: ethers.utils.parseEther(String(totalCost)) })

        console.log('Minting....', nftTx.hash)
        setMiningStatus(0)
        setMintButtonText("MINTING...")
        let tx = await nftTx.wait()
        setLoadingState(1)
        console.log('Minted!', tx)

        let totalmint = parseInt(await nftContract.totalSupply())
        let tokenId = totalmint - 1
        console.log("Token Id is " + tokenId)
        console.log(
          `Mined, see transaction: https://etherscan.io//tx/${nftTx.hash}`

        )
        toast.success("NFT minted successfully \n", {
          toastId: 'success2',
        })
        setMintButtonText("mint more")
        setTotalMinted(totalmint)
        console.log(miningStatus)
        console.log(mintedNFT)
        console.log(loadingState)

      }
      else {

        console.log("Ethereum object doesn't exist!")
      }
    } catch (error) {
      console.log("In minting catch block")

      let errordata = error.data ? error.data.message.split(":")[1] : error.message.split("reverted:")[1].split("\"")[0]
      // let errordata = error.data ? error.data.message.split(":")[1] : error.message
      console.log("error", error.message)
      toast(errordata, {
        type: toast.TYPE.WARNING,
        draggable: true,
        autoClose: 10000,
      });
      setTimeout(function () {
        window.location.reload();
      }, 60 * 1000);

    }
  }

  const checkCorrectNetwork = async () => {
    const { ethereum } = window
    let chainId = await ethereum.request({ method: 'eth_chainId' })
    console.log('Connected to chain:' + chainId)
    const rinkebychainid = '0x4'
    const ethMainnet = '0x1'
    if (chainId !== ethMainnet) {
      setCorrectNetwork(false)
      setMintButtonText("switch to ethereum network first")
    } else {
      setCorrectNetwork(true)
    }
  }
  const checkIfWalletIsConnected = async () => {
    const { ethereum } = window
    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum)
      const signer = provider.getSigner()
      const nftContract = new ethers.Contract(
        nftContractAddress,
        NFT.abi,
        signer
      )
      try {
        let totalMinted = await nftContract.totalSupply()
        setTotalMinted(parseInt(totalMinted))
      }
      catch (error) {
        console.log(error)
        setTotalMinted(0)
      }

      setMintButtonText("Mint Now")
      console.log('Got the ethereum obejct: ', ethereum)
    } else {

      console.log('No Wallet found. Connect Wallet')
    }
    const accounts = await ethereum.request({ method: 'eth_accounts' })
    if (accounts.length !== 0) {
      console.log('Found authorized Account: ', accounts[0])
      setCurrentAccount(accounts[0])
    } else {
      setMintButtonText("Connect wallet")
      connectWallet()
      // console.log('No authorized account found')
    }
  }

  useEffect(() => {
    checkIfWalletIsConnected()
    checkCorrectNetwork()
  }, [])

  const increment = async () => {
    setCounter(counter + 1)
    console.log("incremented")

  }
  const decrement = async () => {
    if (counter > 1) { setCounter(counter - 1) }
    console.log("decremented")
  }
  return (
    <>
      <div className='header-div'>
        <div className='navbar-main w-nav'>
          <div className='container-2 w-container'>
            <a href='/' aria-current='page' className='brand-link w-nav-brand w--current'>
              <img src={Images.siteLogo} loading='lazy' alt='' className='site-logo' width={87} />
            </a>
            <nav className='nav-menu w-nav-menu'>
            <div className='counter-bottom-txt'>
          <div className='rocky-social-links top-social'>
            <a
              href='https://www.instagram.com/rocky_inu_token/'
              target='_blank'
              className='social-link top-socila-align w-inline-block'
              rel='noreferrer'>
              <img src={Images.instagram} loading='lazy' alt='Instagram' className='social-img top-social' />
            </a>
            <a
              href='https://twitter.com/rockyinutoken'
              target='_blank'
              className='social-link top-socila-align w-inline-block'
              rel='noreferrer'>
              <img src={Images.twitter} loading='lazy' alt='' className='social-img top-social' />
            </a>
            <a
              href='https://t.me/rocky_inu_group'
              target='_blank'
              className='social-link top-socila-align w-inline-block'
              rel='noreferrer'>
              <img src={Images.telegram} loading='lazy' alt='' className='social-img top-social' />
            </a>
          </div>
        </div>
              <div>
                {/* <button className="nav--button" onClick={connectWallet}>{walletText}</button> */}

                {currentAccount === '' ? (
                  <button className="nav--button" onClick={connectWallet}>CONNECT WALLET</button>
                  // { connectWallet }

                ) : correctNetwork ? (
                  <button className="nav--button" onClick="">CONNECTED</button>
                ) : (
                  <button className="nav--button" onClick={connectWallet}>CONNECT WALLET</button>
                  // { connectWallet }

                )}
              </div>
            </nav>
            <div className='navbar-smallScreen'>
              <div className='navbar-smallScreen-hamburgerIcon' role='button' onClick={() => classHandler()}>
                <i className={isOpen ? 'open' : 'close'} id='burger__barOne' />
                <i className={isOpen ? 'open' : 'close'} id='burger__barTwo' />
                <i className={isOpen ? 'open' : 'close'} id='burger__barThree' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='hero-section'>
        <div className='mint-img-button'>
          <img src={Images.heroImg} loading='lazy' alt='' className='hero-img' />
          <div className="header--btngroup">
            <div className='inc-buttons'>
              <button className="btn-1" onClick={increment}>+</button>
              <button className="btn-1">{counter}</button>
              <button className="btn-1" onClick={decrement}>-</button>
            </div>
            <br></br>
            <button className="mint--btn" onClick={mintCharacter}>{mintButtonText}</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hero
